// const APP_URL = 'http://localhost:4200';
// const API_URL = 'http://localhost:8000';
const APP_URL = 'https://dev.ocelus.buyerforesight.net';
const API_URL = 'https://dev.api.ocelus.buyerforesight.net';


export const environment = {
    production: false,
    app_url: APP_URL,
    api_url: API_URL,
    google_oauth_client: "261390014380-tracn0na2s28n7jpn9plffnvh5t35aqh.apps.googleusercontent.com",
    google_oauth_client_secret: "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"
};